<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><i class="fa fa-eye mr-5"></i>{{'sap_idocs_error' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-xs-2">
            <select class="form-control" @change="onFilterChange" v-model="filter">
              <option class="normal" value="shippings">{{'shipping' | translate}}</option>
              <option class="normal" value="returns">{{'return' | translate}}</option>
              <option class="normal" value="reductions">{{'reduction' | translate}}</option>
              <option class="normal" value="nothing">{{'all' | translate}}</option>
            </select>
          </div>
          <div class="col-xs-1">
            <select class="form-control" @change="onFilterChange" v-model="year">
              <option v-for="item in years" class="normal" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="box-body">
        <template v-if="this.loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else-if="Object.keys(this.results).length > 0">
          <div id="accordion-test-2" class="panel-group joined">
            <div class="panel panel-default" v-for="(rows, type) in this.results">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a :href="`#collapse-${type}`" data-parent="#accordion-test-2" data-toggle="collapse">
                  {{type | translate}}</a>
                </h4>
              </div>
              <div :id="`collapse-${type}`" class="panel-collapse collapse in">
                <div v-for="(row,index) in rows "class="panel-body">
                  <div :class="['col-xs-6', 'col-lg-4' ]">
                    <router-link :to="`/orders/${row.qb_parent_order_id}`" target="_blank" rel="opener"><strong>{{'order_id' |
                      translate}}: </strong> {{row.qb_parent_order_id}}<i class="fa fa-external-link ml-5"></i>
                    </router-link>
                    <br/>
                    <strong>{{'ext_order_id' | translate}}: </strong>{{row.payment_ref}}<br/>
                    <span v-if="row.payment_ref_addition!=null"><strong>{{'ext_order_id_addition' | translate}}: </strong>{{row.payment_ref_addition}}<br/></span>
                    <strong>{{'payment_method' | translate}}: </strong>{{row.payment_method}}<br/>
                   <strong>{{type+'_line_id' | translate}}: </strong>{{row.line_id}}<br/>
                    <strong>{{type+'_action_date' | translate}}: </strong>{{row.action_date}}<br/>
                    <strong>{{'inbound_date' | translate}}: </strong>
                    <span class="italic small">
                        <span v-if="row.sap_inbound_date === null">
                          {{'no_inbound_date_given'| translate}}
                        </span>
                        <span v-else>
                          {{row.sap_inbound_date}}
                        </span>
                    </span><br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="callout callout-info">
            <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
            <p>Aktuell liegen uns keine offenen Bestellungen die älter als 12 Stunden sind vor, die nicht versendet
              sind.</p>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    data() {
      return {
        filter: "shippings",
        year: (new Date()).getFullYear(),
        years: Array(parseInt((new Date()).getFullYear()) - 2019 + 1).fill().map((_,i) => (2019 + i).toString()), // 2019 bis aktuelles Jahr
        loading: true,
        results: []
      }
    },
    methods: {
      getData() {
        if (this.filter === "nothing") {
          this.getAll()
        }

        if(this.filter === "shippings"){
          this.getShippings()
        }

        if(this.filter === "returns"){
          this.getReturns()
        }

        if(this.filter === "reductions"){
          this.getReductions()
        }

      },
      onFilterChange(){
        this.loading=true
        this.getData()
      },
      getAll() {
        API.get(`monitoring/sap/viewall`, {
          params: {year: this.year}
        })
          .then(response => {
            console.log(response.data)
            this.loading = false
            this.results = response.data
          })
          .catch(error => {
            this.checkError(error)
          })
      },
      getShippings() {
        API.get(`monitoring/sap/viewOrders`, {
          params: {year: this.year}
        })
          .then(response => {
            this.results = response.data
            this.loading = false
          })
          .catch(error => {
            this.checkError(error)
          })
      },
      getReturns() {
        API.get(`monitoring/sap/viewReturns`, {
          params: {year: this.year}
        })
          .then(response => {
            this.results = response.data
            this.loading = false
          })
          .catch(error => {
            this.checkError(error)
          })
      },
      getReductions() {
        API.get(`monitoring/sap/viewReductions`, {
          params: {year: this.year}
        })
          .then(response => {
            this.results = response.data
            this.loading = false
          })
          .catch(error => {
            this.checkError(error)
          })
      },

    },
    mounted() {
      this.$nextTick(() => {
        this.getData()
      })
    }
  }
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }

  .picker .monthItem .item.active:hover {
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0, 195, 150, .4) !important;
    border-color: rgba(0, 195, 150, 1) !important;

  }
</style>
<style scoped>
  .panel {
    background-color: #282a31 !important;
  }

  .panel-heading {
    background-color: #212228 !important;
  }

  .img-responsive {
    display: inline !important;
    width: 16px !important;
  }
</style>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }

  .italic {
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Overviews/SapOverview.vue